import styled from 'styled-components';

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${props => (props.active ? '#4A4A4A' : '#9B9B9B')};
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;

  > span {
    position: relative;
    z-index: 5;
  }
`;
